import styled, { css } from 'styled-components';
import Grid from 'atoms/Layout/Grid/Grid';
import { cssVar, mediaQuery } from 'styles/helper';

const IconCardGridContainer = styled(Grid)`
  grid-row-gap: ${cssVar('spacing-7xl')};
  grid-column-gap: ${cssVar('spacing-4xl')};

  ${mediaQuery(
    'md',
    css`
      grid-row-gap: ${cssVar('spacing-5xl')};
    `
  )}
`;

export default IconCardGridContainer;
